// ref: https://reacttricks.com/sharing-global-data-in-next-with-custom-app-and-usecontext-hook/

import { createContext, useContext, useState, useCallback } from "react"

const GlobalStateContext = createContext({})

export const GlobalStateProvider = ({ children, site: initialSite, locale, page }) => {
    // TODO: add Craft channels data here? needed by presentations & possibly other components
    const [site, setSite] = useState(initialSite)

    const setEmmaMeetingId = useCallback((id) => {
        setSite((prev) => ({
            ...prev,
            meeting: { ...prev.meeting, emmaMeetingId: id },
        }))
    }, [])

    return <GlobalStateContext.Provider value={{ site, locale, page, setEmmaMeetingId }}>{children}</GlobalStateContext.Provider>
}

export const useGlobalState = () => useContext(GlobalStateContext)
